export default __webpack_public_path__ + "d37667f8fc76568e6153897a7df6efe4.png";